import { PopupIconComponent } from './popup-icon.component';

export default angular
  .module('sfMobile.components.popup-icon', ['sfMobile.components.popup'])
  .component('sfPopupIcon', PopupIconComponent).name;
